import { connect } from 'react-redux';
import AppBar from '../components/app_bar/app_bar';

function mapStateToProps({ auth }) {
  return {
    user: auth.user,
  };
}

export default connect(mapStateToProps)(AppBar);



// WEBPACK FOOTER //
// ./src/containers/app_bar.js